module.exports = {  
  btnText:{
    name1:'确认',
    name2:'返回首页',
    name3: '取消'
  },
  text:{    
    name1:'我已认真阅读',
    name2: '用户使用协议',
    name3: '隐私权政策',
    name4: '温馨提示',
    name5: '已阅读协议并同意',
    name6: '不同意并退出系统',
    name7: '欢迎使用本系统！',
    name8: '在您使用本软件前，请您认真阅读并同意',
    name9: '用户使用协议',
    name10:'隐私权政策'
  },  
  addressV2:{
    name1: '取消',
    name2: '选择地址',
    name3: '确定',
    name4: '请选择'
  },  
  empty:{
    name1:'暂无数据',
    name2:'已经到底了',
    name3:'没有更多了'
  },
  date:{
    name1:'年',
    name2:'月',
    name3:'日',
    name4:'时',
    name5:'分'
  },
  address:{
    name1:'福建',
    name2:'厦门',
    name3:'思明区',
  },
  error:{    
     name1:'请勿重复提交',
     name2:'请选择完整地址',
     name3:'请勾选“本人保证上述内容真实，如有虚假，愿意承担法律责任。',
  },
  dialog:{
     name1:'温馨提示',
     name2:'请再次确认填写信息，若无误请点击确认',
     name3:'审核拒绝后，将无法撤销，请谨慎操作！',
     name4:'通过'
  },
  success:{
    name1:'提交成功',
    name2:'通过成功',
    name3:'拒绝成功',
  },
  identityChoice: {
    name1: '重要通知',
    name2: '请选择您的身份'
  },
  home: {
    name1: '重要通知'
  },
  personnellist:{
    name1: '人员列表',
    name2: '男',
    name3: '女',
    name4: '岁',
    name5: '个月',
    name6: '手机号',
    name7: '填报日期',
    name8: '新增人员登记',
    name9: '健康记录',
  },
  healthInfoIdByCardNo:{
    name1: '姓名',
    name2: '证件类型',
    name3: '身份证号',
    name4: '监护人身份证号',
    name5: '护照号码',
    name6: '证件号码',
    name7: '证件号码',
    name8: '下一步',
    name9: '选择证件类型',
    name10: '请输入姓名',
    name11: '请输入',
    name12: '居民身份证',
    name13: '监护人身份证',
    name14: '护照',
    name15: '港澳居民来往内地通行证',
    name16: '台湾居民来往大陆通行证',
    name17: '请输入姓名',
    name18: '请选择证件类型',
    name19: '请输入身份证号码',
    name20: '请输入护照',
    name21: '请输入港澳居民来往内地通行证',
    name22: '请输入台湾居民来往大陆通行证'
  },
  healthrecord:{    
    name1: '健康记录',
    name2: '症状',
    name3: '咳嗽',
    name4: '乏力',
    name5: '气促',
    name6: '胸闷',
    name7: '腹泻',
    name8: '无',
    name9: '其他',
    name10: '体温',
    name11: '入院治疗患者',
    name12: '收治医院',
    name13: '入院时间',
    name14: '出院时间',
    name15: '责任医生',
    name16: '联系电话',
    name17: '随访结果',
    name18: '正常完成',
    name19: '未见到管理对象',
    name20: '其他',
    name21: '随访情况',
    name22: '自录',
    name23: '新增健康记录',
    name24: '当前还没有健康记录哦'
  },
  temperature:{ 
name1:  '新增健康记录',
name2:  '登记时间',
name3:  '请选择',
name4:  '体温',
name5:  '请选择体温',
name6:  '入院治疗患者',
name7:  '是',
name8:  '否',
name9:  '收治医院',
name10: '请输入收治医院',
name11: '入院时间',
name12: '请选择日期',
name13: '出院时间',
name14: '请选择日期',
name15: '症状【多选】',
name16: '咳嗽',
name17: '气促',
name18: '其他',
name19: '请描述您的症状',
name20: '无以上症状',
name21: '责任医生',
name22: '请输入责任医生',
name23: '联系电话',
name24: '请输入联系电话',
name25: '随访结果',
name26: '正常完成',
name27: '未见到管理对象',
name28: '其他',
name29: '保存',
name30: '请选择登记时间',
name31: '请选择体温',
name32: '请输入收治医院',
name33: '请选择入院时间',
name34: '请选择出院时间',
name35: '请勾选症状',
name36: '请输入责任医生',
name37: '请输入责任医生电话',
name38: '请输入医生正确的手机号码',
name39: '请选择随访结果',
  },
  registration:{    
    name1:  '申报登记',
    name2:  '与您的关系',
    name3:  '请选择与您的关系',
    name4:  '姓名',
    name5:  '请输入姓名',
    name6:  '性别',
    name7:  '请选择性别',
    name8:  '证件类型',
    name9:  '身份证号',
    name10: '监护人身份证号',
    name11: '护照号码',
    name12: '证件号码',
    name13: '证件号码',
    name14: '请输入',
    name15: '出生日期',
    name16: '请选择日期',
    name17: '年龄',
    name18: '岁',
    name19: '月龄',
    name20: '请输入',
    name21: '月',
    name22: '手机号码',
    name23: '请输入手机号码',
    name24: '企业名称',
    name25: '请输入企业名称',
    name26: '紧急联系人',
    name27: '请输入紧急联系人',
    name28: '紧急联系电话',
    name29: '请输入紧急联系电话',
    name30: '建卡时健康状况',
    name31: '请选择建卡时健康状况',
    name32: '现住地址',
    name33: '请选择',
    name34: '现住地址详情',
    name35: '请输入现住地址详情',
    name36: '建档机构',
    name37: '请选择建档机构',
    name38: '归属居委会',
    name39: '请选择归属居委会',
    name40: '人员',
    name41: '请选择人员类型',
    name42: '入闽时间',
    name43: '入闽目的',
    name44: '请选择入闽目的',
    name45: '来闽曾停留县区',
    name46: '请输入来闽曾停留县区',
    name47: '来闽交通方式',
    name48: '请选择来闽交通方式',
    name49: '具体班次',
    name50: '请输入你所乘坐的班次编号',
    name51: '接触时间',
    name52: '请选择日期',
    name53: '接触后曾停留县',
    name54: '请输入接触后曾停留县',
    name55: '个人及家属返厦前行程经历 ',
    name56: '14天内到过或经过疫情较重地方',
    name57: '14天内接触疫情较重地方人员',
    name58: '接触病毒感染或疑似人员',
    name59: '14天内曾居住/旅游/途经湖北',
    name60: '出省（除湖北外)',
    name61: '出国出境',
    name62: '无以上经历',
    name63: '出发地点',
    name64: '请选择',
    name65: '出发时间',
    name66: '请选择日期',
    name67: '来厦时间',
    name68: '请选择日期',
    name69: '来厦目的',
    name70: '请选择来厦目的',
    name71: '来厦交通方式',
    name72: '请选择来厦交通方式',
    name73: '班次信息',
    name74: '航班号',
    name75: '车次',
    name76: '班车车号',
    name77: '车牌号',
    name78: '出租车号',
    name79: '轮船',
    name80: '请输入',
    name81: '备注',
    name82: '其他需要说明事项',
    name83: '基础疾病情况',
    name84: '无',
    name85: '高血压',
    name86: '糖尿病 ',
    name87: '脑卒中',
    name88: '冠心病',
    name89: '哮喘',
    name90: '其他',
    name91: '过敏史',
    name92: '请入过敏史',
    name93: '选择与您的关系',
    name94: '选择性别',
    name95: '选择证件类型',
    name96: '选择建卡时健康状况',
    name97: '选择人员类型',
    name98: '选择是否湖北籍',
    name99: '选择目的',
    name100: '选择建档机构',
    name101: '选择交通工具',
    name102: '本人保证上述内容真实',
    name103: '如有虚假，愿意承担法律责任。',
    name104: '保存',
    name105: '保存',
    name106: '拒绝',
    name107: '通过',
    name108: '本人',
    name109: '父亲',
    name110: '母亲',
    name111: '配偶',
    name112: '孩子',
    name113: '是',
    name114: '否',
    name115: '男',
    name116: '女',
    name117: '居民身份证',
    name118: '监护人身份证',
    name119: '护照',    
    name120: '港澳居民来往内地通行证',
    name121: '台湾居民来往大陆通行证',
    name122: '已入院',
    name123: '已隔离',
    name124: '不适症状',
    name125: '无症状',
    name126: '飞机',
    name127: '火车',
    name128: '班车',
    name129: '自驾',
    name130: '出租车',
    name131: '轮船',
    name132: '来自或密切接触湖北人员',
    name133: '来自或密切接触境外人员',
    name134: '返乡',
    name135: '探亲',
    name136: '旅游',
    name137: '出差',
    name138: '工作',
    name139: '学习',
    name140: '请选择与您的关系',
    name141: '请输入姓名',
    name142: '请输入性别',
    name143: '请输入年龄',
    name144: '请输入身份证号码',
    name145: '请输入护照',
    name146: '请输入港澳居民来往内地通行证',
    name147: '请输入台湾居民来往大陆通行证',
    name148: '请输入手机号码',
    name149: '请输入紧急联系人',
    name150: '请输入紧急联系电话',
    name151: '请选择建卡时健康状况',
    name152: '请选择现住地址',
    name153: '请输入现住地址详情',
    name154: '请选择建档机构',
    name155: '请选择归属居委会',
    name156: '请选择人员类型',
    name157: '请选择入闽时间',
    name158: '请选择入闽目的',
    name159: '请选择入闽交通工具',
    name160: '请输入来闽曾停留县区',
    name161: '请输入你所乘坐的班次编号',
    name162: '请选择接触时间',
    name163: '请选择出发地点',
    name164: '请选择出发时间',
    name165: '请选择来厦时间',
    name166: '请选择来厦目的',
    name167: '请选择来厦通工具',
    name168: '请勾选个人及家属返厦前行程经历',
    name169: '请勾选基础疾病情况',
    name170: '请输入正确的手机号码',
    name171: '请输入正确紧急联系电话',
    name172: '请输入有效的证件号码',
    name173: '请输入有效的护照',
    name174: '紧急联系电话与本人手机号码不能相同！'
  } 
}